import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/public`,
  }),
  tagTypes: ['PublicBankDetails'],
  endpoints: (builder) => ({
    // Get bank details for public use (onboarding)
    getPublicBankDetails: builder.query({
      query: () => '/bank-details',
      providesTags: ['PublicBankDetails'],
    }),
  }),
});

export const {
  useGetPublicBankDetailsQuery,
} = publicApi;